/**
 * @repo/ui/utils - 工具函数统一导出
 */

import http from "./http"

export { default as usePreventScrollPenetration } from "./hooks"
export type * from "./http"
export default http
